import React, { useRef } from "react";
import "../styles/Tabs.css";

/**
 * Tabs nach dem ARIA-Muster: ein einziger Tab-Stopp (roving tabindex),
 * Pfeiltasten wechseln, Home und End springen an den Rand.
 *
 * `tabs` sind { id, label }, `value` die aktive id.
 */
export const Tabs = ({ tabs, value, onChange, label }) => {
  const listRef = useRef(null);

  const focusTab = (id) => {
    onChange(id);
    // Nach dem Wechsel soll der Fokus dem neuen Tab folgen.
    requestAnimationFrame(() => {
      listRef.current?.querySelector(`#tab-${id}`)?.focus();
    });
  };

  const onKeyDown = (event) => {
    const index = tabs.findIndex((tab) => tab.id === value);
    if (index === -1) return;

    const moves = {
      ArrowRight: (index + 1) % tabs.length,
      ArrowLeft: (index - 1 + tabs.length) % tabs.length,
      Home: 0,
      End: tabs.length - 1,
    };

    const next = moves[event.key];
    if (next === undefined) return;

    event.preventDefault();
    focusTab(tabs[next].id);
  };

  return (
    <div className="tabs" role="tablist" aria-label={label} ref={listRef} onKeyDown={onKeyDown}>
      {tabs.map((tab) => {
        const active = tab.id === value;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            id={`tab-${tab.id}`}
            className={active ? "tabs__tab tabs__tab--active" : "tabs__tab"}
            aria-selected={active}
            aria-controls={`panel-${tab.id}`}
            tabIndex={active ? 0 : -1}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
